module.exports = __webpack_public_path__ + "img/male_resultB.caae60f6.png";